import type { Bcp47Locale } from '@backmarket/http-api/src/standards/Locale'

export default function createCountryFormatter(locale: Bcp47Locale) {
  return (countryCode: string) => {
    if (typeof Intl.DisplayNames !== 'function') {
      return countryCode
    }

    const regionNames = new Intl.DisplayNames([locale], {
      type: 'region',
    })

    try {
      return regionNames.of(countryCode) || countryCode
    } catch {
      // `of` throws a RangeError when the code is not a valid region subtag
      // (empty string, masked value, free text…)
      return countryCode
    }
  }
}
